import React, { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

type Props = {
  children: ReactNode
  footer?: ReactNode
}

export const SidepanelWrapper = ({ children, footer }: Props) => {
  return (
    <Box
      className="absolute right-2 z-50"
      role="dialog"
      aria-label="Node configuration"
      style={{
        top: '16px',
        maxHeight: 'calc(100% - 80px)',
        width: '564px',
      }}
      background="white"
      border={{ all: { width: 's1', color: 'grey300', style: 'solid' } }}
      borderRadius={{ all: 'abs012' }}
      flexDirection="column"
    >
      <Box
        style={{ overflowY: 'auto' }}
        paddingY="s20"
        paddingX="s16"
        gap="s16"
        flexGrow
        borderRadius={{ topLeft: 'abs012', topRight: 'abs012' }}
      >
        {children}
      </Box>
      {footer && (
        <Box
          style={{
            borderTop: '1px solid #E5E7EB',
            background: '#F9FAFB',
          }}
          padding="s16"
          borderRadius={{ bottomLeft: 'abs012', bottomRight: 'abs012' }}
        >
          {footer}
        </Box>
      )}
    </Box>
  )
}
